import logo from '../img/Air NZ logo.png';
import alliance from '../img/star alliance logo (white).png';
import fb from '../img/Social/Facebook.png';
import ig from '../img/Social/Instagram.png';
import tw from '../img/Social/Twitter.png';
import yt from '../img/Social/Youtube.png';

const Footer = () => {
  return (
    <div className="footer text-right">
     {/* <div className="scroll-down text-center absolute">
            <p>Back to the top</p>
            <a href="#top"><img src={scrolldown} alt="scroll-down"/></a>
  </div>*/}
        <div className="row pb-5 pb-sm-0 align-items-center">
          <div className="col-6">
            <div className="footerSocials mobile">
              <ul>
                  <li><a href="#"><img src={fb}/></a></li>
                  <li><a href="#"><img src={ig}/></a></li>
                  <li><a href="#"><img src={tw}/></a></li>
                  <li><a href="#"><img src={yt}/></a></li>
              </ul>
          </div>
          </div>
          <div className="col-6">
            <div className="footerLogo"><img src={logo}/></div>
          </div>
        </div>
        <div className="footerSocials py-5 desktop">
            <ul>
                <li><a href="#"><img src={fb}/></a></li>
                <li><a href="#"><img src={ig}/></a></li>
                <li><a href="#"><img src={tw}/></a></li>
                <li><a href="#"><img src={yt}/></a></li>
            </ul>
        </div>
        <div className="alliance"><img src={alliance}/></div>
        <div className="footerCopyright pt-2">Copyright © 2023 Air New Zealand Limited</div>
    </div>
  );
};
export default Footer;
